var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection } from './utils';
const initialState = {
    data: [],
    loading: false,
    count: 0,
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const createTakeFlags = createAsyncThunk('takesFlags/create', (flags_1, _a) => __awaiter(void 0, [flags_1, _a], void 0, function* (flags, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.takeFlags.collection.create(flags);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const deleteTakeFlags = createAsyncThunk('takesFlags/delete', (flags_1, _a) => __awaiter(void 0, [flags_1, _a], void 0, function* (flags, { fulfillWithValue, rejectWithValue }) {
    try {
        const flagsIds = flags.map((flag) => ({ id: flag.id }));
        yield api.takeFlags.collection.delete(flagsIds);
        return fulfillWithValue(flagsIds);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createAndDeleteTakeFlags = createAsyncThunk('takeFlags/createAndDelete', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ flagsToCreate, flagsToDelete }, { fulfillWithValue, rejectWithValue }) {
    try {
        const flagsIds = flagsToDelete.map((flag) => ({ id: flag.id }));
        const toCreate = flagsToCreate.length && api.takeFlags.collection.create(flagsToCreate);
        const toDelete = flagsIds.length && api.takeFlags.collection.delete(flagsIds);
        const [response] = yield Promise.all([toCreate, toDelete]);
        return fulfillWithValue({ response: response || [], flagsIds });
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
// actions for middleware
export const createTakeFlagsAction = createTakeFlags.fulfilled;
export const deleteTakeFlagsAction = deleteTakeFlags.fulfilled;
export const createAndDeleteTakeFlagsAction = createAndDeleteTakeFlags.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxTakesFlags',
    initialState,
    reducers: {
        setAllRelTakesFlags: (state, { payload }) => {
            state.data = payload;
        },
    },
    extraReducers: (builder) => {
        // CREATE FLAG RELATION
        builder.addCase(createTakeFlags.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createTakeFlagsAction, (state, { payload }) => {
            const newData = payload.map((relation) => ({
                id: relation.id,
                take: relation.take,
                flag: relation.flag,
            }));
            state.data = [...state.data, ...newData];
        });
        builder.addCase(createTakeFlags.rejected, (state) => {
            state.loading = false;
        });
        // DELETE FLAG RELATION
        builder.addCase(deleteTakeFlags.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteTakeFlagsAction, (state, { payload }) => {
            const idsArr = payload.map((el) => el.id);
            const updatedData = deleteDataFomCollection(state.data, idsArr);
            state.data = updatedData;
        });
        builder.addCase(deleteTakeFlags.rejected, (state) => {
            state.loading = false;
        });
        // CREATE AND DELETE FLAG RELATION
        builder.addCase(createAndDeleteTakeFlags.pending, () => { });
        builder.addCase(createAndDeleteTakeFlagsAction, (state, { payload }) => {
            const { response, flagsIds } = payload;
            const idsArr = flagsIds.map((el) => el.id);
            const t = [...state.data, ...response];
            const cleanedData = removeDuplicates(t, (flag) => flag.id);
            const newData = deleteDataFomCollection(cleanedData, idsArr);
            state.data = newData;
        });
        builder.addCase(createAndDeleteTakeFlags.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllRelTakesFlags } = actions;
export default reducer;
